<div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
  <div class="col-md-11 body-class">
    <h1>Gestion NA (Nature Analytique P3P4)</h1>
  </div>
  <div class="col-md-1 body-class" style="padding-top: 15px;">
    <button class="pull-right" color="warn" mat-raised-button type="button" (click)="onLeave()">
      <mat-icon>cancel</mat-icon> Fermer
    </button>
  </div>
</div>
<div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
  <div class="col-md-8">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Rechercher une NA (nature analytique)</mat-label>
      <input matInput [(ngModel)]="objet.query" (change)="search()" (keydown.enter)="search()" placeholder="Code, libelle du NA">
    </mat-form-field>
  </div>
  <div class="col-md-1 top">
    <button type="button" mat-raised-button color="primary" (click)="onCreate()" mat-icon-button><mat-icon>add</mat-icon></button>
  </div>
  <div class="col-md-1 top">
    <button mat-raised-button color="primary" type="button" (click)="search()" style="color: white;"mat-icon-button><mat-icon>search</mat-icon></button>
  </div>
</div>  
<div class="col-md-12">
  <div class="mat-table">
    <div class="table_principale">
      <table mat-table matSort [dataSource]="matDataSource" multiTemplateDataRows class="mat-elevation-z8" (matSortChange)="sortData($event)" matSortActive="code">
        <caption>Liste des natures analytique</caption>
        <ng-container matColumnDef="code">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Code </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> {{element.code}} </td>
        </ng-container>
    
        <ng-container matColumnDef="libelle">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Libellé </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{element.libelle}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="cgCharge">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> CG Charge </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{getCgByCode(element.cgCharge)}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="analyt2">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> CA2 </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> 
            <div class="left" *ngIf="element.analyt2"> Oui</div>
            <div class="left" *ngIf="!element.analyt2"> Non</div>
           </td>
        </ng-container>

        <ng-container matColumnDef="typeComp">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Type de complément </th>
          <td mat-cell *matCellDef="let element" (click)="onModify(element)"> <div class="left">{{getTypeCompByCode(element.typeComp)}}</div> </td>
        </ng-container>
    
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element" style="padding: 0;">
            <div class="center">
              <span *ngIf="element.agenceId !== null" (click)="onDelete(element)">
                <mat-icon class="red-icon">close</mat-icon>
              </span>
            </div>
          </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns, sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
      </table>
    
      <div class="footer">
        <mat-paginator
          #paginator
          [length]="length"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 25, 50]"
          (page)="changePage($event)">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
